import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import PageLoading from '../../../components/PageLoading/PageLoading'
import InformationTable from '../../../components/Table/InformationTable'
import { dateToString, monthToString } from '../../../utils/date'
import MesRecienteSelector from '../../../components/form/MesRecienteSelector/MesRecienteSelector'
import { getEvaluacionesAlumno } from '../../../utils/api/evaluacion'
import { useNotification } from '../../../context/NotificationManager/NotificationManager'
import useAlumno from '../../../hooks/useAlumno'
import AlumnoHeader from '../../../components/AlumnoHeader/AlumnoHeader'
import css from './Evaluacion.module.css'

const FACE_ICONS = {
  MUY_POSITIVA: 'sentiment_very_satisfied',
  POSITIVA: 'sentiment_satisfied',
  NEUTRAL: 'sentiment_neutral',
  NEGATIVA: 'sentiment_dissatisfied',
  MUY_NEGATIVA: 'sentiment_very_dissatisfied'
}

const FaceIcon = ({ value }) => {
  if (!value || !FACE_ICONS[value]) return <span>-</span>
  return (
    <i className={`material-icons ${css.faceIcon}`} data-valoracion={value}>
      {FACE_ICONS[value]}
    </i>
  )
}

const Evaluacion = () => {
  const { id } = useAlumno()
  const notification = useNotification()
  const [mes, setMes] = useState(monthToString(new Date()))

  const { isLoading, data: evaluacionList = [] } = useQuery({
    queryKey: ['evaluacion-alumnos', 'list', 'alumno', id, mes],
    enabled: !!mes,
    queryFn: () =>
      getEvaluacionesAlumno({ alumnoId: id, mes })
        .then(datos =>
          datos.sort((a, b) => new Date(b.fecha) - new Date(a.fecha))
        )
        .catch(err => {
          notification.error({
            title: 'Error al recuperar las evaluaciones',
            content: err
          })
          return []
        })
  })

  return (
    <PageLoading isLoading={isLoading}>
      <div>
        <AlumnoHeader label='Evaluaciones' />
        <MesRecienteSelector
          className={css.mes}
          name='mes'
          label='Mes'
          value={mes}
          backwardOptions={2}
          forwardOptions={1}
          onChange={e => setMes(e.target.value)}
        />
      </div>

      <InformationTable
        details={[
          { title: 'Fecha', key: 'fecha' },
          { title: 'Profesor', key: 'profesor' },
          { title: 'Actitud', key: 'actitud', sortDisabled: true },
          { title: 'Limpieza', key: 'limpieza', sortDisabled: true },
          { title: 'Eficacia', key: 'asignaturas', sortDisabled: true },
          { title: 'Observaciones', key: 'observaciones', sortDisabled: true }
        ]}
        data={evaluacionList.map(evaluacion => ({
          fecha: dateToString(evaluacion.fecha),
          profesor: evaluacion.profesor || '-',
          actitud: <FaceIcon value={evaluacion.actitud} />,
          limpieza: <FaceIcon value={evaluacion.limpieza} />,
          asignaturas: (
            <div className={css.asignaturasList}>
              {(evaluacion.asignaturas || []).map((item, idx) => (
                <div key={idx} className={css.asignaturaRow}>
                  <span className={css.asignaturaNombre}>
                    {item.asignatura}:
                  </span>
                  <FaceIcon value={item.valoracion} />
                </div>
              ))}
            </div>
          ),
          observaciones: evaluacion.observaciones || '-'
        }))}
      />
    </PageLoading>
  )
}

export default Evaluacion
